import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ApproacheSection from "./components/ApproacheSection";
import Services from "./components/Services";
import Calculator from "./components/Calculator";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ImageBanner from "./components/ImageBanner";
import Admin from "./components/Admin";
import SeoContent from "./components/SeoContent";
import PageGestionPatrimoineAnnecy from "./pages/PageGestionPatrimoineAnnecy";
import PageOptimisationFiscaleAnnecy from "./pages/PageOptimisationFiscaleAnnecy";
import PageInvestissementImmobilierAnnecy from "./pages/PageInvestissementImmobilierAnnecy";
import PageFrontaliersSuisse from "./pages/PageFrontaliersSuisse";

const Home = () => {
  return (
    <div>
      <Header />
      <main>
        <Hero />
        
        {/* Trust Stats Band - brown circle highlights */}
        <div style={{
          background: 'var(--bg-cream)',
          padding: '3rem 0',
          borderBottom: '1px solid rgba(172, 153, 105, 0.1)'
        }}>
          <div className="container">
            <div className="stats-row" style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '3.5rem',
              textAlign: 'center',
              flexWrap: 'wrap'
            }}>
              {[
                { value: '+ 70', label: 'Foyers accompagnés' },
                { value: '+ 85%', label: 'Issu de la recommandation' },
                { value: '100%', label: 'Clients satisfaits' }
              ].map((stat, idx) => (
                <div key={idx} data-testid={`stat-${idx}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{
                    width: '110px',
                    height: '110px',
                    borderRadius: '50%',
                    border: '3px solid var(--primary-brown)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '0.85rem',
                    background: 'rgba(58, 46, 15, 0.03)',
                    boxShadow: '0 4px 18px rgba(58, 46, 15, 0.08)'
                  }}>
                    <span style={{
                      fontFamily: "'Playfair Display', serif",
                      fontSize: '1.65rem',
                      fontWeight: '600',
                      color: 'var(--primary-brown)',
                      lineHeight: 1
                    }}>{stat.value}</span>
                  </div>
                  <p style={{
                    color: 'var(--text-muted)',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    margin: 0,
                    maxWidth: '160px'
                  }}>
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <ApproacheSection />

        {/* Bandeau 1 - Flèche qui monte */}
        <ImageBanner 
          imageUrl="https://customer-assets.emergentagent.com/job_02301d40-e1b7-4c3b-a98b-eccef76882c0/artifacts/ry3vkzn5_ChatGPT%20Image%2024%20mars%202026%2C%2022_22_12.png"
          height="160px"
        />

        <Services />

        {/* Bandeau 2 - Boussole */}
        <ImageBanner 
          imageUrl="https://images.unsplash.com/photo-1519992599773-1e1d4029929d"
          height="160px"
        />

        {/* Remuneration disclosure - shown discreetly before testimonials */}
        <div style={{
          background: 'var(--bg-cream)',
          padding: '1.75rem 0',
          borderTop: '1px solid rgba(172, 153, 105, 0.15)'
        }}>
          <div className="container">
            <p data-testid="remuneration-note" style={{
              maxWidth: '780px',
              margin: '0 auto',
              textAlign: 'center',
              fontSize: '0.85rem',
              lineHeight: 1.7,
              color: 'var(--text-muted)',
              fontStyle: 'italic'
            }}>
              Ma rémunération se fait uniquement par mes partenaires et fournisseurs de solutions,
              au même titre qu'un courtier immobilier. Mon activité repose également sur la
              recommandation de mes clients satisfaits.
            </p>
          </div>
        </div>
        <Testimonials />

        {/* Bandeau 3 - Personnes */}
        <ImageBanner 
          imageUrl="https://images.unsplash.com/photo-1758519289714-519a9d9b96e3"
          height="160px"
        />

        <Contact />
        <Calculator />
      </main>
      <SeoContent />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activ-patrimoine-admin" element={<Admin onClose={() => window.location.href = '/'} />} />
          {/* Invisible SEO landing pages - not linked from main nav, only reachable via Google */}
          <Route path="/gestion-patrimoine-annecy" element={<PageGestionPatrimoineAnnecy />} />
          <Route path="/optimisation-fiscale-annecy" element={<PageOptimisationFiscaleAnnecy />} />
          <Route path="/investissement-immobilier-locatif-annecy" element={<PageInvestissementImmobilierAnnecy />} />
          <Route path="/conseiller-patrimonial-frontaliers-suisse" element={<PageFrontaliersSuisse />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
